module.exports = __webpack_public_path__ + "img/ao.7c939321.jpg";